import React from 'react';
import styled from 'styled-components';
import {
  ClockIcon,
  MapPinIcon,
  StarIcon,
  UsersIcon,
  AcademicCapIcon,
  CameraIcon,
  GlobeAltIcon,
  HeartIcon,
  BookOpenIcon
} from '@heroicons/react/24/outline';

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${props => props.theme.colors.textSecondary};
  font-size: 0.875rem;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

const AmenityIcons = {
  // Time/Duration
  Duration: ({ minutes, className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <ClockIcon className="w-4 h-4" />
      </IconWrapper>
      <span>{minutes} min</span>
    </IconContainer>
  ),

  // Location
  Location: ({ location, className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <MapPinIcon className="w-4 h-4" />
      </IconWrapper>
      <span>{location}</span>
    </IconContainer>
  ),

  // Rating/Stars
  Rating: ({ rating, className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <StarIcon className="w-4 h-4" style={{ fill: '#FF385C', color: '#FF385C' }} />
      </IconWrapper>
      <span>{rating}</span>
    </IconContainer>
  ),

  // Age Group
  AgeGroup: ({ ageRange, className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <UsersIcon className="w-4 h-4" />
      </IconWrapper>
      <span>Age {ageRange}</span>
    </IconContainer>
  ),

  // Educational
  Educational: ({ className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <AcademicCapIcon className="w-4 h-4" />
      </IconWrapper>
      <span>Educational</span>
    </IconContainer>
  ),

  // Historical
  Historical: ({ className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <BookOpenIcon className="w-4 h-4" />
      </IconWrapper>
      <span>Historical</span>
    </IconContainer>
  ),

  // Interactive
  Interactive: ({ className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <GlobeAltIcon className="w-4 h-4" />
      </IconWrapper>
      <span>Interactive</span>
    </IconContainer>
  ),

  // Photo Opportunity
  PhotoOpportunity: ({ className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <CameraIcon className="w-4 h-4" />
      </IconWrapper>
      <span>Photo Spot</span>
    </IconContainer>
  ),

  // Favorite
  Favorite: ({ className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <HeartIcon className="w-4 h-4" />
      </IconWrapper>
      <span>Popular</span>
    </IconContainer>
  ),

  // Games Available
  GamesAvailable: ({ count, className }) => (
    <IconContainer className={className}>
      <IconWrapper>
        <StarIcon className="w-4 h-4" style={{ fill: '#FF385C', color: '#FF385C' }} />
      </IconWrapper>
      <span>{count} game{count !== 1 ? 's' : ''}</span>
    </IconContainer>
  )
};

export default AmenityIcons;

